<script lang="ts" setup>
const { layer } = useLayers()
</script>

<template>
  <div class="max-w-none prose prose-inherit prose-img:rounded prose-h1:font-normal prose-h1:text-2xl prose-ul:pl-5 prose-li:pl-1">
    <slot />
  </div>
</template>

<style scoped>
:deep(li > input[type=checkbox]:first-child) {
  appearance: none;
  background-color: rgb(v-bind('layer.bgCssVar'));
  cursor: pointer;
  display: inline-block;
  height: 1rem;
  margin-left: -1.5rem;
  margin-bottom: 1.25em;
  outline: none;
  vertical-align: middle;
  border-radius: 0.125rem;
  border: 0.25rem solid rgb(v-bind('layer.bgCssVar'));
  width: 1rem;
}

:deep(li > input[type=checkbox]:first-child:checked) {
  background-color: rgb(v-bind('layer.textCssVar'));
}

:deep(pre) {
  background-color: rgb(v-bind('layer.bgCssVar'));
  color: rgb(v-bind('layer.textCssVar'));
}
</style>
